const MarketInsight = () => import(/* webpackChunkName: "MarketInsight" */ '@/views/MarketInsight')
const MarketCreate = () => import(/* webpackChunkName: "MarketCreate" */ '@/views/MarketInsight/marketCreate')
const MarketProductAdd = () => import(/* webpackChunkName: "MarketCreate" */ '@/views/MarketInsight/marketProductAdd')
const marketInsightRouter = [
  {
    // path: '', 或者 重定向
    path: '/marketInsight',
    component: MarketInsight,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Market Insight'
    }
  },
  {
    path: '/marketInsight/marketCreate',
    component: MarketCreate,
    meta: {
      title: 'Market Create'
    }
  },
  {
    path: '/marketInsight/marketProductAdd',
    component: MarketProductAdd,
    meta: {
      title: 'Market Product Add'
    }
  }
]

export default marketInsightRouter
